import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal } from 'antd'
import { downloadAttachment } from 'action/article'
import React from 'react'
import PropTypes from 'prop-types'

const { error, success } = Modal

const MODAL_TEXT = {
  okText: 'Close',
  outcome: {
    content: {
      error: 'Please try Again',
      success: 'This Attachment will download automatically when ready'
    },
    title: {
      error: 'There has been an issue downloading this attachment',
      success: 'Attachment downloading'
    }
  }
}

const DownloadAttachment = ({ downloadAttachment, attachment }) => {
  const handleClick = async () => {
    const successModal = success({
      content: MODAL_TEXT.outcome.content.success,
      okText: MODAL_TEXT.okText,
      title: MODAL_TEXT.outcome.title.success
    })

    const successful = await downloadAttachment(attachment.uuid)

    if (!successful) {
      successModal.destroy()
      error({
        content: MODAL_TEXT.outcome.content.error,
        okText: MODAL_TEXT.okText,
        title: MODAL_TEXT.outcome.title.error
      })
    }
  }

  return (
    <a onClick={handleClick}>Download Attachment</a>
  )
}

DownloadAttachment.propTypes = {
  attachment: PropTypes.object,
  downloadAttachment: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  downloadAttachment: bindActionCreators(downloadAttachment, dispatch)
})

export default connect(
  null,
  mapDispatchToProps
)(DownloadAttachment)
